export const PAGE_NAMES = {
  DETAILS: 'storeDetails',
  HOME_SERVICES: 'homeServices',
  RENTALS: 'rentals',
  GARDEN_CENTER: 'gardenCenter',
  PRO_DESK: 'proDesk',
  LOCAL_CITY_PAGE: 'lcp',
};